import { head, prop, propEq, propOr } from 'ramda'
import React from 'react'

const Context = React.createContext()
const { Provider } = Context

export const useTabsState = () => React.useContext(Context)
export const useSetTabByName = () => prop('setTabByName', useTabsState())
export const useActiveTab = () => propOr({}, 'tab', useTabsState() || {})
export const useActiveTabName = () => prop('name', useActiveTab())
export const useTabOptions = () => propOr([], 'options', useTabsState() || {})
export const useSetTab = () => prop('setTab', useTabsState())

export const TabsContext = ({ defaultValue, options, onChangeTab, ...props }) => {
  options = React.useMemo(() => (options || []).map((option, index) => ({ ...option, index })), [options.length])
  const [tab, setTab] = React.useState(defaultValue || head(options))
  const handleSetTab = newTab => {
    if (onChangeTab) onChangeTab(newTab)
    setTab(newTab)
  }
  const setTabByName = name => handleSetTab(options.find(propEq('name', name)))
  return <Provider value={{ tab, options, setTab: handleSetTab, setTabByName }} {...props} />
}
